import React from "react";
import "./StatusDisplay.scss";

export default function StatusDisplay(props) {
  const { status, className } = props;
  const newClassName = ["StatusDisplay", className].join(" ");

  return <p className={newClassName}>{status}</p>;
}
